import { useContext } from "react";
import {
  NotificationContext,
  NotificationContextProps,
} from "./NotificationProvider";

export const useNotification = (): NotificationContextProps =>
  useContext(NotificationContext);
